<template>
  <div class="content-8">
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename"><span class="c8-titlename__text">和值走势</span></div>
      </div>
      <div class="content-8__titlebar__right">
        <LotteryDateFilterTab
          @updateForm="updateForm"
        />
      </div>
    </div>

    <Loading v-if="isLoading" />
    <div v-if="trendList.length > 0 && !isLoading">
      <!-- 和值走势 -->

      <LotteryPresentSelector
        :component-name="$options.name"
        @changePresent="changePresent"
      />

      <div class="content-8__content">
        <div class="table-scroll">
          <table class="even-color" style="position: relative;" draw-root>
            <thead>
              <tr>
                <th rowspan="2"><span>期号</span></th>
                <th rowspan="2"><span>开奖号码</span></th>
                <th rowspan="2">和值</th>
                <th :colspan="headNumColspanSize"><span>和值走势</span></th>
                <th :colspan="headXingTaiColspanSize"><span>和值形态</span></th>
              </tr>
              <tr>
                <th
                  v-for="(num, index) in numList"
                  :key="`num-${num.key}-${index}`"
                  v-text="num.label"
                ></th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="(trendItem, trendIndex) in trendList"
                :key="`trend-${trendItem.period}`"
                :class="{ 'tr-bottom-border': presentLineDivided && !((trendIndex + 1) % 5) }"
              >
                <td>
                  <span v-text="trendItem.period"></span>
                </td>
                <td>
                  <div class="continuous-text">
                    <span
                      v-for="(ball, ballIndex) in trendItem.balls"
                      :key="`trend-${trendItem.period}-${ballIndex}`"
                      class="continuous-text__text"
                      :class="{ red: `hm${ballIndex + 1}` === currentHm }"
                      v-text="ball"
                    ></span>
                  </div>
                </td>
                <td>
                  <span v-text="trendItem.all"></span>
                </td>
                <td
                  v-for="{ key: numKey } in numList"
                  :key="`num-${numKey}`"
                  :set="item = trendItem.missing[currentHm][numKey] /* for shorten html */"
                  :class="{
                    'bg-col': trendItem.missing[currentHm][numKey].drawType === 'num',
                    'yiloufc': presentLineMissingLayer && trendItem.missing[currentHm][numKey].isMissingLayer,
                    'bg-orange': trendItem.missing[currentHm][numKey].isOrange,
                    'bg-blue': trendItem.missing[currentHm][numKey].isBlue,
                    'bg-red': trendItem.missing[currentHm][numKey].isRed,
                    'isDraw': trendItem.missing[currentHm][numKey].isDraw
                  }"
                >
                  <div v-if="/^all_num/.test(numKey) && item.isDraw" class="tableballbox" :item-type="item.drawType">
                    <div class="tableballbox__item">
                      <div class="ball circle color--blue size-middle">
                        <span
                          class="ball__number"
                          v-bind="item.drawMap"
                          v-text="item.label"
                        ></span>
                      </div>
                    </div>
                  </div>
                  <span
                    v-else
                    v-show="item.isDraw || presentMissing"
                    v-bind="item.drawMap"
                    v-text="item.label"
                  ></span>
                </td>
              </tr>
            </tbody>

            <thead statistic-dom>
              <tr>
                <th colspan="2" rowspan="2">数据统计 <statisticTip /></th>
                <th rowspan="2">和值</th>
                <th :colspan="headNumColspanSize"><span>和值走势</span></th>
                <th :colspan="headXingTaiColspanSize"><span>和值形态</span></th>
              </tr>
              <tr>
                <th v-for="num in numList" :key="`statistic-${num.key}`" v-text="num.label"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="statisticItem in statisticList"
                :key="`statistic-${statisticItem.statisticType}`"
              >
                <td colspan="2">
                  <span v-text="statisticItem.label"></span>
                </td>
                <td>
                  <span>-</span>
                </td>
                <td
                  v-for="(num, index) in numList"
                  :key="`statistic-num-${num.key}-${index}`"
                >
                  <span v-text="statisticItem.data[currentHm][num.key]"></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <NoData v-if="trendList.length === 0 && !isLoading" />
  </div>
</template>

<script>
import {
  commonTrendMethods_web,
  drawTrendCanvas,

  basicNumList,
  numList,
  hmList,
  presentSelectorComputedVariable
} from '@/utils/flyc-temp/lotteryLib'

import LotteryDateFilterTab from '@/components/web/pages/trend/LotteryDateFilterTab'
import LotteryPresentSelector from '@/components/web/common/LotteryPresentSelector'
import Loading from '@/components/web/common/Loading'
import NoData from '@/components/web/common/NoData'
import statisticTip from '@/components/web/common/statisticTip'
// k3, 11x5

export default {
  name: 'WebHeJhihZouShih', // 和值走勢
  components: {
    LotteryDateFilterTab,
    LotteryPresentSelector,
    Loading,
    NoData,
    statisticTip
  },
  props: {
    lotteryType: {
      type: String,
      default: '',
      requried: true
    }
  },
  data() {
    return {
      lotteryCode: this.$route.params.lottery_code,

      // 組出這個頁面會用到的api
      trendTypes: ['zongHe', 'zongHeDanShuang', 'zongHeDaXiao'],
      // 用來畫canvas 的key
      lineArray: ['all_num'],

      form: {
        count: 30
      },

      trendList: [],
      currentHm: 'all',

      statisticSort: ['appearCount', 'avgMissing', 'now', 'biggestContinue', 'biggestMissing'],
      statisticList: [],

      present: {
        presentMissing: true,
        presentLine: true,
        presentLineDivided: false,
        presentLineMissingLayer: false
      },
      isLoading: true
    }
  },
  computed: {
    headNumColspanSize() {
      const { lotteryType } = this
      switch (lotteryType) {
        case 'k3':
          return 16
        case '11x5':
          return 31
        default:
          console.warn('headNumColspanSize: lotteryType 對應失敗! 將使用 1', lotteryType)
          return 1
      }
    },
    headXingTaiColspanSize() {
      const { lotteryType } = this
      switch (lotteryType) {
        case 'k3':
          return 5
        case '11x5':
          return 5
        default:
          console.warn('headXingTaiColspanSize: lotteryType 對應失敗! 將使用 1', lotteryType)
          return 1
      }
    },

    ...basicNumList,
    ...hmList,
    ...numList, // TODO: 這裡的numList 會不會其實和api 一樣放個兩層的會比較好?
    ...presentSelectorComputedVariable
  },
  watch: {
    presentLine(presentLine) {
      if (presentLine) {
        this.drawMultiTrendCanvas()
        return
      }
      this.removeMultipleTrendCanvas()
    }
  },
  async created() {
    await this.getTrendData()

    if (this.trendList.length) this.drawMultiTrendCanvas()
  },
  mounted() {
    window.vm = this
  },
  updated() {
    this.initLazyLoading()
  },
  methods: {
    ...commonTrendMethods_web,
    ...drawTrendCanvas,
    afterFormatTrendData(list) {
      list.forEach((item) => {
        const all = item.balls.reduce((accum, ball) => accum + ball, 0)
        Object.assign(item, { all })
      })
      return list
    }
  }
}
</script>
